<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 621.18 621.18" style="fill:none;stroke:#000;stroke-width:24.81px"><rect class="cls-1" x="11.59" y="11.59" width="598" height="598" rx="71.14"/><line class="cls-1" x1="11.59" y1="228.97" x2="609.59" y2="228.97"/><line class="cls-1" x1="11.59" y1="370.67" x2="609.59" y2="370.67"/><line class="cls-1" x1="310.59" y1="366.76" x2="310.59" y2="226.97"/><circle cx="79.58" cy="78.14" r="15.33"/><circle cx="133.25" cy="78.14" r="15.33"/><circle cx="186.91" cy="78.14" r="15.33"/></svg>
</template>

<script>
export default {}
</script>
